import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 09 2018
 * @author LZe
 */
import * as React from 'react';
import { InputValidated } from '../../../../inputs/Input';
import CellEditor from './CellEditor';
import { KeyCode } from '../../../../../shared/keyboard/KeyCode';
import { bigdecimal, DecimalRoundingEnum } from '@logio/big-decimal';
import { NumberUtils, Utils } from '@logio/common-be-fe';
/**
 * Number editor for the AgGrid
 * @extends CellEditor
 */

var NumberEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(NumberEditor, _CellEditor);

  function NumberEditor(props) {
    var _this;

    _classCallCheck(this, NumberEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberEditor).call(this, props));
    /**
     * Handles changes of the input element
     */

    _this.onChange = function (event) {
      var numString = event.target.value !== '' ? event.target.value : null;

      if (!Utils.isNull(numString)) {
        _this.updateValue(_this.roundNumber(numString));
      } else {
        _this.updateValue(null);
      }
    };
    /**
     * LOG-2079 - Select all on focus
     */


    _this.onFocus = function (event) {
      return event.target.select();
    };
    /**
     * LOG-4180 disable count change by UpArrow and DownArrow key press
     */


    _this.onKeyDown = function (e) {
      if (e.keyCode === KeyCode.UpArrow || e.keyCode === KeyCode.DownArrow) {
        e.preventDefault();
      }
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(InputValidated, {
        validationError: _this.state.validationError,
        onKeyDown: _this.onKeyDown,
        type: "number",
        value: !Utils.isValueMissing(_this.state.value) ? _this.state.value : '',
        onChange: _this.onChange,
        onFocus: _this.onFocus,
        className: "ag-cell-editor",
        tiny: true
      }));
    };

    return _this;
  }

  _createClass(NumberEditor, [{
    key: "applyCharPress",
    value: function applyCharPress(charPress) {
      return this.state.value ? "".concat(this.state.value).concat(charPress) : charPress;
    }
  }, {
    key: "applyMaxDecimalPlaces",
    value: function applyMaxDecimalPlaces(numString, maxDecimalPlaces) {
      var places = NumberUtils.countDecimalPlaces(numString);
      return !Utils.isValueMissing(maxDecimalPlaces) && maxDecimalPlaces >= 0 && maxDecimalPlaces < places;
    }
  }, {
    key: "roundNumber",
    value: function roundNumber(numString) {
      if (this.applyMaxDecimalPlaces(numString, this.props.maxDecimalPlaces)) {
        return bigdecimal(numString).toFixed(this.props.maxDecimalPlaces, DecimalRoundingEnum.ROUND_DOWN);
      }

      return numString;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      // Add char (number) to the edited input element if pressed over the cell
      if (this.props.charPress !== null && !isNaN(+this.props.charPress)) {
        var numString = this.applyCharPress(this.props.charPress);
        this.updateValue(this.roundNumber(numString));
      }
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var validationResult = _get(_getPrototypeOf(NumberEditor.prototype), "validate", this).call(this, value);

      if (validationResult.valid && this.props.colDef.cellEditorParams && this.props.colDef.cellEditorParams.validate) {
        var error = this.props.colDef.cellEditorParams.validate(value, this.props.node);

        if (error) {
          validationResult = error;
        }
      }

      return validationResult;
    }
  }]);

  return NumberEditor;
}(CellEditor);

export { NumberEditor as default };